var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 90,
    viewBox: "0 0 212 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.9512,
    y: 1,
    width: 163.049,
    height: 77.6829,
    rx: 1,
    fill: "#FAFBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9512,
    y: 1,
    width: 163.049,
    height: 64.0244,
    rx: 1,
    fill: "#F9F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4755 20.2073H46.6707H47.0975L47.5243 78.2561H19.7804H1.42676L1.85359 59.0487C2.19505 50.5122 9.39424 48.6626 12.9511 48.8048C13.9755 48.8048 14.5162 47.6666 14.6585 47.0975L23.1951 21.4878C23.5365 20.4634 24.191 20.2073 24.4755 20.2073Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.382 1H48.8656C48.048 1 47.385 1.29906 47.385 1.66797V77.6684C47.385 78.0372 48.048 78.3363 48.8656 78.3363H209.341C210.337 78.3363 211.049 77.9011 210.755 77.4715V1.66797C210.564 1.38791 158.032 1 157.382 1Z",
    stroke: "#AAB7EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999838 78.5694L24.455 78.5323L47.9102 78.4951",
    stroke: "#AAB7EF",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5021 88.7483C24.3779 88.7483 20.224 84.5902 20.224 79.4608C20.224 74.3315 24.3779 70.1733 29.5021 70.1733C34.6263 70.1733 38.7803 74.3315 38.7803 79.4608C38.7803 84.5902 34.6263 88.7483 29.5021 88.7483Z",
    fill: "#F7F8FF",
    stroke: "#AAB7EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5768 83.696C27.1992 83.696 25.2717 81.7666 25.2717 79.3865C25.2717 77.0065 27.1992 75.0771 29.5768 75.0771C31.9544 75.0771 33.8818 77.0065 33.8818 79.3865C33.8818 81.7666 31.9544 83.696 29.5768 83.696Z",
    fill: "#F7F8FF",
    stroke: "#AAB7EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.926 88.5999C156.802 88.5999 152.648 84.4418 152.648 79.3124C152.648 74.1831 156.802 70.0249 161.926 70.0249C167.05 70.0249 171.204 74.1831 171.204 79.3124C171.204 84.4418 167.05 88.5999 161.926 88.5999Z",
    fill: "#F7F8FF",
    stroke: "#AAB7EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162 83.5475C159.622 83.5475 157.695 81.6181 157.695 79.2381C157.695 76.8581 159.622 74.9287 162 74.9287C164.377 74.9287 166.305 76.8581 166.305 79.2381C166.305 81.6181 164.377 83.5475 162 83.5475Z",
    fill: "#F7F8FF",
    stroke: "#AAB7EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.243 88.5999C184.119 88.5999 179.965 84.4418 179.965 79.3124C179.965 74.1831 184.119 70.0249 189.243 70.0249C194.368 70.0249 198.521 74.1831 198.521 79.3124C198.521 84.4418 194.368 88.5999 189.243 88.5999Z",
    fill: "#F7F8FF",
    stroke: "#AAB7EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.317 83.5475C186.939 83.5475 185.012 81.6181 185.012 79.2381C185.012 76.8581 186.939 74.9287 189.317 74.9287C191.695 74.9287 193.622 76.8581 193.622 79.2381C193.622 81.6181 191.695 83.5475 189.317 83.5475Z",
    fill: "#F7F8FF",
    stroke: "#AAB7EF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0754 29.5312H39.7451C40.1549 29.5312 40.4873 29.864 40.4873 30.2743V47.3633C40.4873 47.7735 40.1549 48.1063 39.7451 48.1063H13.9147",
    stroke: "#AAB7EF",
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4278 33.9893H35.5888C35.9987 33.9893 36.3311 34.322 36.3311 34.7323V42.9053C36.3311 43.3155 35.9987 43.6483 35.5888 43.6483H15.548",
    stroke: "#AAB7EF",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10543 67.7214H14.5087C14.9186 67.7214 15.251 68.0542 15.251 68.4644V78.5692",
    stroke: "#AAB7EF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0298 53.0842H38.9287V57.988H34.0298V53.0842Z",
    fill: "#F7F8FF",
    stroke: "#AAB7EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67633 70.7676H10.5752V75.6714H5.67633V70.7676Z",
    fill: "#F7F8FF",
    stroke: "#AAB7EF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.168 19.8721H24.4689C23.8381 19.8721 23.2764 20.2711 23.0678 20.8668L18.2944 34.5092L14.3701 47.3967C14.1864 47.9998 13.6425 48.4213 13.0132 48.448L10.5749 48.5519C8.3234 48.6477 6.17235 49.5523 4.52307 51.0895C3.38282 52.152 2.51572 53.4836 2.00787 54.9579L1.87783 55.3352C1.4929 56.4526 1.28848 57.6244 1.27215 58.8063L0.999898 78.5691",
    stroke: "#AAB7EF",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckProgress);
export default __webpack_public_path__ + "static/media/TruckProgress.842a554256b70c2b4d766d28a3b5c7c6.svg";
export { ForwardRef as ReactComponent };